import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 30, // 30 minutes default
      gcTime: 1000 * 60 * 60, // 60 minutes
      retry: (failureCount, error: unknown) => {
        // Don't retry on 4xx errors
        const err = error as { response?: { status?: number } };
        if (err.response?.status && err.response.status >= 400 && err.response.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
